import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GetExaminedDto } from '../autogenerated/spdApiClient/models/GetExaminedDto';

export type ExaminedEntity = GetExaminedDto;

export interface ExportContextInterface {
  exportTest: (id: string) => Promise<Blob>;
}

export const ExportContext = (api: DefaultApi) => {
  return {
    exportTest: async (ident: string) => {
      return await api.exportControllerExportTestResults(ident);
    },
  };
};
